// @ts-ignore
import * as styles from './styles/index.scss'
import { globals } from '@/src/globals'

/* Layout - Imports */
import { header } from './scripts/layout/header'

/* Elements - Imports */
import { gridGallery } from './scripts/elements/gridGallery'
import { wysiwyg } from './scripts/elements/wysiwyg'
import { input } from './scripts/elements/input'
import { image } from './scripts/elements/image'
import { button } from './scripts/elements/button'

/* Components - Imports */
import { promoText } from './scripts/components/promoText'
import { employeeList } from './scripts/components/employeeList'
import { certificateList } from './scripts/components/certificateList'
import { contactInfo } from './scripts/components/contactInfo'
import { testimonialsList } from './scripts/components/testimonialsList'
import { expandListWithForm } from './scripts/components/expandListWithForm'
import { gridTopBanner } from './scripts/components/gridTopBanner'
import { contactForm } from './scripts/components/contactForm'
import { whereToUseBlock } from './scripts/components/whereToUseBlock'
import { uspLine } from './scripts/components/uspLine'

/* Pages - Imports */

/*
  -----------------------------------
  MAIN FILE
  -----------------------------------
*/
const falcosolar = (globalData: any): void => {
  const processedStyles = styles
  globals.externalInput = globalData

  /* Layout */
  header()

  /* Elements */
  gridGallery()
  wysiwyg()
  input()
  image()
  button()

  /* Components */
  promoText()
  employeeList()
  certificateList()
  contactInfo()
  testimonialsList()
  expandListWithForm()
  gridTopBanner()
  contactForm()
  whereToUseBlock()
  uspLine()

  /* Pages */
}

export default falcosolar
